import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { DialogData } from 'src/app/pages/management/tiersetup/tiersetup.component';
import { PeriodsService } from 'src/app/service/periods.service';

@Component({
    selector: 'app-copy-tier-dialog',
    templateUrl: './copy-tier-dialog.component.html',
    styleUrls: ['./copy-tier-dialog.component.scss'],
    standalone: false
})
export class CopyTierDialogComponent implements OnInit {
  heading: string;
  fromPeriodLabel: string;
  toPeriodList = [];
  selected_period_id;
  selected_period_value
  enableError = false;
  errormsg: string;
  constructor(public dialogRef: MatDialogRef<CopyTierDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: DialogData,
    private readonly periodsService : PeriodsService, private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly constants: Constants) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.fromPeriodLabel = this.dataStore.fromPeriodLabel
    this.getPeriods();
  }
  getPeriods() {
    const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
    if (tempPeriod && tempPeriod.length > 0) {
      this.toPeriodList = tempPeriod
      this.selected_period_id = this.toPeriodList[0].periodId;
      this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period  // NOSONAR
    } else {
      this.periodsService.getPeriodsList().subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response.length > 0) {
            this.toPeriodList = response
            this.selected_period_id = this.toPeriodList[0].periodId;
            this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period  // NOSONAR
          }
        }, error => {
          console.info(error)
          this.errormsg = this.constants.APIErrorMessage
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        }
      );
    }
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick() {

    if (this.selected_period_id) {
      this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period  // NOSONAR
      if (this.fromPeriodLabel == this.selected_period_value) {
        this.enableError = true;
        this.errormsg = "From and To Period cannot be same, please change."
      } else
       { this.dialogRef.close({
          event: "SaveEvent", selected_period_id: this.selected_period_id, selected_period_value: this.selected_period_value
        }); }
    } else {
      this.enableError = true;
      this.errormsg = "select to-period"
    }
  }

}
